import { InjectionToken } from "@angular/core";

export const LOGGER = new InjectionToken("logger");
